export default "__VITE_ASSET__C9GsaIQ3__"